export default __webpack_public_path__ + "static/media/vDoge.0d88b93b.svg";